import { VALID } from 'common/const';

const FIELD = {
  address1: {
    label: 'Address 1',
    validation: VALID.ADDRESS.required('Address is required'),
  },
  address2: {
    label: 'Address 2',
    placeholder: 'Municipality',
    optional: true,
    validation: VALID.ADDRESS_2,
  },
  city: {
    label: 'City',
    validation: VALID.CITY.required('City is required'),
  },
  state: {
    label: 'State',
    validation: VALID.PROVINCE.required('State is required'),
  },
  zip: {
    label: 'Postal Code',
    validation: VALID.POSTAL_CODE.required('Postal code is required'),
  },
};

export default FIELD;
